import { render, staticRenderFns } from "./InputRenderer.vue?vue&type=template&id=04a4dc8b"
import script from "./InputRenderer.vue?vue&type=script&lang=js"
export * from "./InputRenderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports